import React from 'react';

const SprayTask = (props) => {
	return "[spray record: summary]";
}

SprayTask.getdataformat = () => {
	return {
		'rows': [],
		'other stuff': {}
	}
};

export default SprayTask;